/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p",
    pre: "pre",
    code: "code",
    h2: "h2"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.h1, {
    id: "navlink"
  }, "NavLink"), "\n", React.createElement(_components.p, null, "Link component for use in navigation"), "\n", React.createElement(_components.pre, null, React.createElement(_components.code, {
    className: "language-js"
  }, "import { NavLink } from 'theme-ui'\n")), "\n", React.createElement(_components.pre, null, React.createElement(_components.code, {
    className: "language-jsx",
    live: "true"
  }, "<Flex as=\"nav\">\n  <NavLink href=\"#!\" p={2}>\n    Home\n  </NavLink>\n  <NavLink href=\"#!\" p={2}>\n    Blog\n  </NavLink>\n  <NavLink href=\"#!\" p={2}>\n    About\n  </NavLink>\n</Flex>\n")), "\n", React.createElement(_components.h2, {
    id: "variants"
  }, "Variants"), "\n", React.createElement(_components.p, null, "NavLink variants can be defined in the ", React.createElement(_components.code, null, "theme.links"), " object.\nBy default the NavLink component will use styles defined in ", React.createElement(_components.code, null, "theme.links.nav"), "."), "\n", React.createElement(_components.pre, null, React.createElement(_components.code, {
    className: "language-js"
  }, "// example theme variants\n{\n  links: {\n    nav: {\n      px: 2,\n      py: 1,\n      textTransform: 'uppercase',\n      letterSpacing: '0.2em',\n    }\n  }\n}\n")));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
